import { render, staticRenderFns } from "./BillDebtReportXL.vue?vue&type=template&id=4135e5a8&"
import script from "./BillDebtReportXL.vue?vue&type=script&lang=js&"
export * from "./BillDebtReportXL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports